import React, { useState } from "react";
import { MdMenu } from "react-icons/md";
import { Route, Routes } from "react-router-dom";
import navContext from "../Context/navContext";
import Client from "./Components/Client/Client";
import Header from "./Components/Header/Header";
import Nav from "../Nav/Nav";

import logo from "../../assets/logo.svg";
// import logo from "../../assets/logo.svg";
import Salarie from "./Components/Salarie/Salarie";
import Documents from "./Components/Document/Document";
import DashBoardMain from "./Components/DashBoardMain/DashBoardMain";
import USer from "./Components/USer/USer";
import Profil from "./Components/Profil/Profil";
import Simulation from "./Components/Simulation/Simulation";
import Log from "../Log/Log";
import ListMeeting from "./Components/Meeting/Meeting";
import Share from "./Components/Share/Share";
import ListShareDetails from "./Components/ShareDetails/ShareDetails";
import ListClientDocPaie from "./Components/ListClientDocPaie/ListClientDocPaie";
import ListSalarieDocRh from "./Components/ListSalarieDocRh/ListSalarieDocRh";

const Main = () => {
  const [nav, setNav] = useState({
    links: [
      {
        href: "/main/dashboard",
        linkname: "Accueil",
      },
    ],
    children: "",
  });
  const navFunction = (value) => {
    setNav({ ...value });
  };

  const showHeader = () => {
    document.querySelector(".header").classList.add("show");
  };

  return (
    <div className="main">
      <navContext.Provider value={navFunction}>
        <Header />
        <div className="content">
          <div className="header-responsive">
            <div className="menu-btn" onClick={showHeader}>
              <MdMenu size="40px" />
            </div>
            <img src={logo} alt="logo" className="header-responsive__logo" />
          </div>
          <Nav links={nav.links}>{nav.children}</Nav>
          <Routes>
            <Route
              path="/client/:clientId/share/:shareId/details/*"
              element={<ListShareDetails />}
            />
            <Route path="/client/:clientId/share/*" element={<Share />} />

            <Route path="/client/*" element={<Client />} />
            <Route path="/salarie/*" element={<Salarie />} />
            <Route path="/document/*" element={<Documents />} />
            <Route path="/dashboard" element={<DashBoardMain />} />
            <Route path="/users/*" element={<USer />} />
            <Route path="/simulation/*" element={<Simulation />} />
            <Route path="/profil" element={<Profil />} />
            <Route path="/docpaie" element={<ListClientDocPaie />} />
            <Route path="/docrh" element={<ListSalarieDocRh />} />
            <Route path="/logs" element={<Log />} />
            <Route path="/meeting" element={<ListMeeting />} />

            <Route path="/*" element={<div>Erreur</div>} />
          </Routes>
        </div>
      </navContext.Provider>
    </div>
  );
};

export default Main;
